// extracted by mini-css-extract-plugin
export default {"groupHeader":"Group-module__groupHeader--fe39","groupTitle":"Group-module__groupTitle--c379"};